import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingCartIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const check = () => {
      const anchor = document.getElementById('hero-cta');
      if (!anchor) return;
      setVisible(anchor.getBoundingClientRect().bottom < 0);
    };
    check();
    window.addEventListener('scroll', check, {
      passive: true
    });
    window.addEventListener('resize', check);
    return () => {
      window.removeEventListener('scroll', check);
      window.removeEventListener('resize', check);
    };
  }, []);
  return <AnimatePresence data-id="element-34" data-mp="2av1rs2qqff0o">
      {visible && <motion.div initial={{
      y: 24,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 24,
      opacity: 0
    }} transition={{
      duration: 0.24,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 flex justify-center px-4 pb-4 sm:bottom-4 sm:pb-0" data-id="element-35" data-mp="38ap5aq9nnyae">
          <a href={CHECKOUT_URL} className="animate-cta-shake flex w-full max-w-md items-center justify-center gap-3 rounded-2xl bg-accent px-5 py-4 font-display text-[17px] font-extrabold uppercase text-white shadow-[0_6px_0_#C9520A,0_12px_30px_rgba(0,0,0,0.3)] focus:outline-none focus-visible:ring-4 focus-visible:ring-accent/40" data-id="element-36" data-mp="333sue33nt8wc">
            <ShoppingCartIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-37" data-mp="2kd1oxcmsm2n8" />
            Get Instant Access — $27
          </a>
        </motion.div>}
    </AnimatePresence>;
}